import React from 'react';
import './GenesisAiContent.scss';

// Keyword-driven AI section for the /local ads landing pages only.
// `response` is the { title, body } object the parent page already fetches.
export default function GenesisAiContent({ response }) {
    if (!window.location.pathname.startsWith('/local')) return null;
    if (!response || !response.title) return null;

    return (
        <div className="GenesisAiContent">
            <div className="GenesisAiContentCard">
                <span className="GenesisAiContentEyebrow">Rocket Air Care</span>
                <h2>{response.title}</h2>
                <p>{response.body}</p>
                <span className="GenesisAiContentDivider"></span>
            </div>
        </div>
    );
}
